import { render, staticRenderFns } from "./relatorioPropostaRetrato.vue?vue&type=template&id=0f1bd106"
import script from "./relatorioPropostaRetrato.vue?vue&type=script&lang=js"
export * from "./relatorioPropostaRetrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports